import { z } from "zod";

// Mirrors TimelineActivityDataDTO — the `data` payload of category=activity.
// `timeTo` is NULL when the activity has no end time or no `time` at all, so
// the only thing this parser guarantees is a string when the backend sent one.
const activityDataSchema = z.object({
	timeTo: z.string().nullish(),
});

export type ActivityData = z.infer<typeof activityDataSchema>;

export const parseActivityData = (data: unknown): ActivityData | null => {
	const result = activityDataSchema.safeParse(data);
	return result.success ? result.data : null;
};
